// Note: careful, this code is shared between client and server side.

function UserError(message, field, code) {
	this.name = 'UserError';
	if (Error && Error.captureStackTrace) { Error.captureStackTrace(this, UserError); }

	this.field = field || '';
	this.code = code || 400;
	this.message = message;
}

UserError.prototype = Object.create(Error.prototype);
UserError.prototype.constructor = UserError;

module.exports = UserError;
